import React from "react";

const Pagination = ({ currPage, totalPage, setPage, count, pageSize, handlePageSizeChange}) => {
  let currPageSize = pageSize > count ? count : pageSize;

  return (
    <>
      <div className="mat-paginator-range-actions">
        <div className="mat-paginator-page-size ng-star-inserted d-flex">
          <div className="mat-paginator-page-size-label">Items per page: </div>
          <select className="mat-select" value={pageSize} onChange={handlePageSizeChange}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="100">100</option>
          </select>
        </div>
        <div className="mat-paginator-range-label">
          {" "}
          {currPage * currPageSize + 1} –{" "}
          {currPage === totalPage - 1 ? count : (currPage + 1) * currPageSize} of {count}{" "}
        </div>
        <button
          type="button"
          className={`mat-focus-indicator arrow-btn ${
            currPage === 0 ? "disabled" : ""
          }`}
          onClick={() => setPage(false)}
        >
          <span className="mat-button-wrapper">
            <svg
              viewBox="0 0 24 24"
              focusable="false"
              className="mat-paginator-icon"
            >
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
          </span>
        </button>
        <button
          type="button"
          className={`mat-focus-indicator arrow-btn ${
            currPage === totalPage - 1 ? "disabled" : ""
          }`}
          onClick={() => setPage(true)}
        >
          <span className="mat-button-wrapper">
            <svg
              viewBox="0 0 24 24"
              focusable="false"
              className="mat-paginator-icon"
            >
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </span>
        </button>
      </div>
    </>
  );
};

export default Pagination;
